import React from 'react'
import LineTagAltIcon from 'components/Luxkit/Icons/line/LineTagAltIcon'
import LineGlobeAltIcon from 'components/Luxkit/Icons/line/LineGlobeAltIcon'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import LineGlassMartiniAltIcon from 'components/Luxkit/Icons/line/LineGlassMartiniAltIcon'
import LineRefundIcon from 'components/Luxkit/Icons/line/LineRefundIcon'
import { ValueSectionItem } from 'home/components/ValuePropositionBanner/ValuePropositionItems'

export const uspContent = (regionCodeContext: string): ValueSectionItem[] => {
  return [
    {
      key: 'save',
      icon: <LineTagAltIcon size="S" />,
      heading: 'Save up to 70%',
      body: 'We negotiate directly with our travel partners to secure exclusive offers you won\'t find elsewhere.',
      show: true,
    },
    {
      key: 'bonus',
      icon: <LineGlassMartiniAltIcon size="S" />,
      heading: 'Bonus inclusions',
      body: 'Handpicked inclusions and exclusive extras will make your trip even more memorable.',
      show: true,
    },
    {
      key: 'oneStop',
      icon: <LineGlobeAltIcon size="S" />,
      heading: 'One-stop travel shop',
      body: 'Discover 1,000s of flights, hotels, packages, tours, cruise, experiences, car hire & more.',
      show: true,
    },
    {
      key: 'flexible',
      icon: <LineRefundIcon size="S" />,
      heading: 'Flexible bookings',
      body: 'Travel with peace of mind thanks to our flexible booking and cancellation policies.',
      show: true,
    },
    {
      key: '24hrService',
      icon: <LinePhoneIcon size="S" />,
      heading: '24/7 customer service',
      body: 'Regardless of your time zone, we offer round-the-clock service.',
      show: regionCodeContext !== 'IN',
    },
    {
      key: '12hrService',
      icon: <LinePhoneIcon size="S" />,
      heading: 'Customer Support',
      body: 'Available seven days a week from 9am to 9pm, ensuring support when you need it most.',
      show: regionCodeContext === 'IN',
    },
  ]
}
